import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden text-white bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23ffffff%22%20fill-opacity%3D%220.05%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%222%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-60"></div>

      {/* Animated Background Elements */}
      <div className="absolute w-32 h-32 rounded-full top-20 left-10 bg-emerald-500/10 animate-float"></div>
      <div className="absolute w-24 h-24 rounded-full top-40 right-20 bg-cyan-500/10 animate-float animate-float-delay-2s"></div>
      <div className="absolute w-16 h-16 rounded-full bottom-20 left-1/4 bg-teal-500/10 animate-float animate-float-delay-4s"></div>

      <div className="relative container-modern section-modern">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4 lg:gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-8 space-x-4">
              <div className="relative">
                <div className="flex items-center justify-center w-16 h-16 shadow-2xl rounded-3xl bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500">
                  <span className="text-2xl font-bold text-white notranslate">
                    M
                  </span>
                </div>
                <div className="absolute w-6 h-6 rounded-full -top-2 -right-2 bg-gradient-to-br from-amber-400 to-orange-500 animate-pulse shadow-lg"></div>
                <div className="absolute w-4 h-4 rounded-full -bottom-1 -left-1 bg-gradient-to-br from-purple-400 to-pink-500 animate-bounce-gentle"></div>
              </div>
              <div className="flex flex-col notranslate">
                <span className="text-3xl font-bold text-transparent bg-gradient-to-r from-white via-emerald-200 to-cyan-200 bg-clip-text">
                  MealBridge
                </span>
                <span className="-mt-1 text-sm font-bold text-amber-400 tracking-wider">
                  SRI LANKA
                </span>
              </div>
            </div>
            <p className="max-w-md mb-8 text-lg leading-relaxed text-slate-300">
              Connecting surplus food with those in need across Sri Lanka.
              Together, we're building a sustainable future and stronger
              communities.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="p-4 transition-all duration-500 transform group bg-white/10 backdrop-blur-xl rounded-2xl hover:bg-white/20 hover:-translate-y-2 hover:scale-110 hover:shadow-2xl hover:shadow-emerald-500/20"
              >
                <span className="sr-only">Facebook</span>
                <svg
                  className="w-6 h-6 transition-colors duration-500 text-slate-400 group-hover:text-white group-hover:scale-110"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>
              <a
                href="#"
                className="p-4 transition-all duration-500 transform group bg-white/10 backdrop-blur-xl rounded-2xl hover:bg-white/20 hover:-translate-y-2 hover:scale-110 hover:shadow-2xl hover:shadow-cyan-500/20"
              >
                <span className="sr-only">Instagram</span>
                <svg
                  className="w-6 h-6 transition-colors duration-500 text-slate-400 group-hover:text-white group-hover:scale-110"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987c6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297L3.182 17.635l1.935-1.935c.807.807 1.958 1.297 3.323 1.297c2.58 0 4.677-2.097 4.677-4.677s-2.097-4.677-4.677-4.677s-4.677 2.097-4.677 4.677c0 1.365.49 2.516 1.297 3.323l-1.935 1.935l1.944-1.944c.875.807 2.026 1.297 3.323 1.297z" />
                </svg>
              </a>
              <a
                href="#"
                className="p-4 transition-all duration-500 transform group bg-white/10 backdrop-blur-xl rounded-2xl hover:bg-white/20 hover:-translate-y-2 hover:scale-110 hover:shadow-2xl hover:shadow-teal-500/20"
              >
                <span className="sr-only">Twitter</span>
                <svg
                  className="w-6 h-6 transition-colors duration-500 text-slate-400 group-hover:text-white group-hover:scale-110"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="relative mb-8 text-xl font-bold text-white">
              Quick Links
              <div className="absolute left-0 w-16 h-1 rounded-full -bottom-3 bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500"></div>
            </h3>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/find-food"
                  className="flex items-center transition-all duration-500 text-slate-300 hover:text-white group transform hover:translate-x-2"
                >
                  <div className="w-2 h-2 mr-4 transition-all duration-500 rounded-full bg-emerald-400 group-hover:bg-emerald-300 group-hover:scale-125"></div>
                  <span className="font-semibold">Find Food</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/donate"
                  className="flex items-center transition-all duration-500 text-slate-300 hover:text-white group transform hover:translate-x-2"
                >
                  <div className="w-2 h-2 mr-4 transition-all duration-500 rounded-full bg-emerald-400 group-hover:bg-emerald-300 group-hover:scale-125"></div>
                  <span className="font-semibold">Donate Food</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/volunteer"
                  className="flex items-center transition-all duration-500 text-slate-300 hover:text-white group transform hover:translate-x-2"
                >
                  <div className="w-2 h-2 mr-4 transition-all duration-500 rounded-full bg-emerald-400 group-hover:bg-emerald-300 group-hover:scale-125"></div>
                  <span className="font-semibold">Volunteer</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/impact"
                  className="flex items-center transition-all duration-500 text-slate-300 hover:text-white group transform hover:translate-x-2"
                >
                  <div className="w-2 h-2 mr-4 transition-all duration-500 rounded-full bg-emerald-400 group-hover:bg-emerald-300 group-hover:scale-125"></div>
                  <span className="font-semibold">Our Impact</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="relative mb-8 text-xl font-bold text-white">
              Support
              <div className="absolute left-0 w-16 h-1 rounded-full -bottom-3 bg-gradient-to-r from-cyan-500 via-teal-500 to-emerald-500"></div>
            </h3>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/help"
                  className="flex items-center transition-all duration-500 text-slate-300 hover:text-white group transform hover:translate-x-2"
                >
                  <div className="w-2 h-2 mr-4 transition-all duration-500 rounded-full bg-cyan-400 group-hover:bg-cyan-300 group-hover:scale-125"></div>
                  <span className="font-semibold">Help Center</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/safety"
                  className="flex items-center transition-all duration-500 text-slate-300 hover:text-white group transform hover:translate-x-2"
                >
                  <div className="w-2 h-2 mr-4 transition-all duration-500 rounded-full bg-cyan-400 group-hover:bg-cyan-300 group-hover:scale-125"></div>
                  <span className="font-semibold">Food Safety</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/guidelines"
                  className="flex items-center transition-all duration-500 text-slate-300 hover:text-white group transform hover:translate-x-2"
                >
                  <div className="w-2 h-2 mr-4 transition-all duration-500 rounded-full bg-cyan-400 group-hover:bg-cyan-300 group-hover:scale-125"></div>
                  <span className="font-semibold">Guidelines</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="flex items-center transition-all duration-500 text-slate-300 hover:text-white group transform hover:translate-x-2"
                >
                  <div className="w-2 h-2 mr-4 transition-all duration-500 rounded-full bg-cyan-400 group-hover:bg-cyan-300 group-hover:scale-125"></div>
                  <span className="font-semibold">Contact Us</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-12 mt-20 border-t border-white/20">
          <div className="flex flex-col items-center justify-between space-y-6 md:flex-row md:space-y-0">
            <div className="flex flex-col items-center space-y-3 md:flex-row md:space-y-0 md:space-x-8">
              <p className="text-sm font-semibold text-slate-400 notranslate">
                © 2025 MealBridge<sup className="text-[8px]">LK</sup> . All
                rights reserved.
              </p>
              <p className="text-sm font-semibold text-slate-500">
                Built with{" "}
                <span className="text-red-400 animate-pulse">❤️</span> for Sri
                Lanka
              </p>
            </div>
            <div className="flex space-x-8">
              <Link
                to="/privacy"
                className="text-sm font-semibold transition-all duration-500 text-slate-400 hover:text-white hover:underline transform hover:scale-105"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-sm font-semibold transition-all duration-500 text-slate-400 hover:text-white hover:underline transform hover:scale-105"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
